import { Button } from "react-aria-components"
import { Intent, IRecallData, IRecallItem } from "./recallData"
import IconChevronDown from "../../../assets/icons/icon-chevron-down.svg"
import IconChevronUp from "../../../assets/icons/icon-chevron-up.svg"
import { useState } from "react"
import { pascalToReadable } from "../../../helpers/StringHelper"

interface SidePanelRecallInventory {
    data: IRecallData
    functions: { [name: string]: Function }
}

export default function SidePanelRecallInventory({ data, functions }: SidePanelRecallInventory) {
    return (
        <div className="recall-wizard-side-panel">
            <div className="panel-header">
                <h3 className="panel-title">Recall Ref: {data.fullRef}</h3>
                <Button type="button" className="button button--secondary button--secondary--destructive button--small" isDisabled={!data.inventory || data?.inventory?.length === 0} onPress={() => functions.removeAll()}><p className="button-text">Remove All</p></Button>
            </div>
            {data.inventory?.length > 0 &&
                <div className="panel-content-wrapper">
                    <div className="panel-content-header grid-x">
                        <p className="small small-3">Recall Type</p>
                        <p className="small small-3">Case Number</p>
                        <p className="small small-3">Material Type</p>
                        <p className="small small-3">Year</p>
                    </div>
                    {data.inventory.map((item, i) =>
                        <div className="panel-content-inventory">
                            <div className="panel-content-data grid-x">
                                <p className="small-3 textWrap">{pascalToReadable(item.intent)}</p>
                                <p className="small-3 textWrap">{item.reference}</p>
                                <p className="small-3 textWrap">{item.materialType.name}</p>
                                <p className="small-3 textWrap">{item.year}</p>
                            </div>
                            <div className="panel-content-buttons">
                                <Button type="button" className="button button--secondary button--small" onPress={() => functions.edit(item, i)}><p className="button-text">Edit</p></Button>
                                <Button type="button" className="button button--secondary button--secondary--destructive button--small" onPress={() => functions.remove(i)}><p className="button-text">Remove</p></Button>
                            </div>
                            {item.intent === Intent.PartCase && <RequestedPartCases item={item} />}
                        </div>
                    )}
                </div>
            }
            <div className="margin__top--auto">
                <div className="display--flex justifyContent--flex-end gap--xxs margin__top--xxs">
                    <Button type="button" className="button button--secondary button--small" onPress={() => functions.prevStep()}><p className="button-text">Back</p></Button>
                    <Button isDisabled={!data?.inventory || data?.inventory?.length === 0} type="button" className="button button--primary button--small" onPress={() => functions.nextStep()}><p className="button-text">Continue</p></Button>
                </div>
            </div>
        </div>
    )
}


function RequestedPartCases({ item }: { item: IRecallItem }) {
    const [collapsed, setCollapsed] = useState<boolean>(true)

    return (
        <div className="panel-content-requested-slides-wrapper">
            <div className="panel-content-requested-slides-header" onClick={() => setCollapsed(prev => !prev)}>
                <p className="small small--2">Requested part cases:</p>
                {/* Change Icon*/}
                <img src={collapsed ? IconChevronDown : IconChevronUp} />
            </div>
            <div className={`panel-content-requested-slides-list--height collapsible ${collapsed ? "collapsible--collapsed" : ""}`}>
                <div className="panel-content-requested-slides-list">
                    {item.partCases.map(partCase =>
                        <p className="small">{partCase[0].reference} {partCase.length > 1 ? `- ${partCase[partCase.length - 1].reference}` : ""} <span className="small--2">({partCase.length} {partCase.length === 1 ? 'part case' : 'part cases'})</span></p>
                    )}
                </div>
            </div>
        </div>
    )
}